import {
  CodeOutlined,
  EyeInvisibleOutlined,
  FileTextOutlined,
  FolderOpenOutlined,
  FolderOutlined,
  PlaySquareOutlined
} from "@ant-design/icons";
import { Tree, Tooltip } from "antd";

const { DirectoryTree } = Tree;

const Sidebar = ({ treeData = [], selectedNode, onSelect }) => {
  const handleSelect = (keys, info) => {
    if (info.node) {
      onSelect(info.node);
    }
  };

  const renderIcon = ({ data, expanded }) => {
    if (data.contentType === "MODULE") {
      return expanded ? <FolderOpenOutlined /> : <FolderOutlined />;
    }
    if (data.contentType === "LECTURE_SET") {
      return <PlaySquareOutlined />;
    }
    if (data.contentType === "PROBLEM_SET") {
      return <CodeOutlined />;
    }
    return <FileTextOutlined />;
  };

  const renderTitle = (node) => {
    let typeLabel = "Item";
    if (node.contentType === "MODULE") {
      typeLabel = "Module";
    }
    if (node.contentType === "LECTURE_SET") {
      typeLabel = "Lecture Set";
    }
    if (node.contentType === "PROBLEM_SET") {
      typeLabel = "Problem Set";
    }

    return (
      <Tooltip title={typeLabel} placement="right">
        <span
          style={{
            fontStyle: node.isVisible === false ? "italic" : "normal",
            opacity: node.isVisible === false ? 0.6 : 1
          }}
        >
          {node.title}{" "}
          {node.isVisible === false && (
            <EyeInvisibleOutlined style={{ marginLeft: 8, fontSize: "12px" }} />
          )}
        </span>
      </Tooltip>
    );
  };

  return (
    <div
      style={{
        width: "100%",
        flex: 1,
        minHeight: 0,
        overflowY: "auto",
        padding: "16px 0"
      }}
    >
      <DirectoryTree
        style={{ width: "100%" }}
        defaultExpandAll
        onSelect={handleSelect}
        treeData={treeData}
        selectedKeys={selectedNode ? [selectedNode.key] : []}
        titleRender={renderTitle}
        icon={renderIcon}
        showIcon={true}
      />
    </div>
  );
};

export default Sidebar;
